import { hasEmailTypo } from 'utils/helpers/emailCheck';

type Errors = {
    company: string,
    email: string
    fullName: string,
    industry_id: string,
    phone: string,
    ref_employees: string
}

const handleValidateSignup = (values, fullNameRegExp, phoneRegExp, emailRegExp, optionalFields) => {
  const errors = {} as Errors;

  switch (true) {
    case !values.fullName || values.fullName === '':
      errors.fullName = 'Full Name Required';
      break;

    case !fullNameRegExp.test(values.fullName):
      errors.fullName = 'Invalid Full Name';
      break;

    case !values.email || values.email === '':
      errors.email = 'Email Address Required';
      break;

    case !emailRegExp.test(values.email):
      errors.email = 'Invalid Email Address';
      break;
    
    case hasEmailTypo(values.email):
      errors.email = 'Invalid Email Address';
      break;

    case !values.industry_id && !optionalFields.includes('industry_id'):
      errors.industry_id = 'Industry Description Required';
      break;
    
    case !values.phone && !optionalFields.includes('phone'):
      errors.phone = 'Telephone Number Required';
      break;

    case (!optionalFields.includes('phone') || values.phone) && !phoneRegExp.test(values.phone):
      errors.phone = 'Invalid Phone Number';
      break;

    case !values.company || values.company.trim() === '':
      errors.company = 'Name of Work is Required';
      break;

    case (!values.ref_employees || values.ref_employees === '') && !optionalFields.includes('ref_employees') :
      errors.ref_employees = 'Employees Are Required';
      break;

  }
  return errors;
};

export default handleValidateSignup;